import { render, staticRenderFns } from "./RemoveCatError.vue?vue&type=template&id=e6f8357a&scoped=true&"
import script from "./RemoveCatError.vue?vue&type=script&lang=js&"
export * from "./RemoveCatError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f8357a",
  null
  
)

export default component.exports